import { ValidationError } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ValidatorError';
import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import { CommonStateViewModelValidator } from './CommonStateViewModelValidator';
export class StateViewModelValidator extends Validator {
    constructor() {
        super();
        this.commonStateModelValidator = new CommonStateViewModelValidator();
        this.contentActionViewModelValidator = this.commonStateModelValidator.contentActionViewModelValidator;
        this.actionViewModelValidator = this.commonStateModelValidator.actionViewModelValidator;
        this.outputViewModelValidator = this.commonStateModelValidator.outputViewModelValidator;
    }
    validate(model) {
        if (model.$title == '' || model.$title == undefined) {
            throw new ValidationError('The title is required');
        }
        if (!model.$position) {
            throw new ValidationError('The position is required');
        }
        this.commonStateModelValidator.validate(model);
    }
}
